import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-columns',
  templateUrl: './meta-columns.component.html',
  styleUrls: ['./meta-columns.component.css']
})
export class MetaColumnsComponent implements OnInit {
    metaTableKeyno;

    public itemsListMetaColumns: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.metaTableKeyno = this.stateService.getStateParams()['metatable_keyno'];
    }

    private async loadMetaColumns() {
        if (!!this.metaTableKeyno) {
            this.itemsListMetaColumns = await this.datatask.Post(2383, { metatable_keyno: this.metaTableKeyno });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'metacolumn':
                this.stateService?.go('metacolumn', {
                    metatable_keyno: this.metaTableKeyno,
                    metacolumn_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMetaColumns();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaColumns', {
//        templateUrl: 'views/components/views/metaColumns/metaColumns.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'metaColumnsService', function ($stateParams, stateService, metaColumnsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                itemsListMetaColumns: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMetaColumns() {
//                vm.model.itemsListMetaColumns = await metaColumnsService.listMetaColumns({ metatable_keyno: metaTableKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metacolumn':
//                        go({
//                            metatable_keyno: metaTableKeyno,
//                            metacolumn_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMetaColumns();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
